// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  background-color: #f4f4f4;
  background-size: cover;
  background-position: center;
}

.dialog-sidebar {
  width: 250px;
  background-color: #f0f8ff;
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 10;
}

.logo {
  margin-bottom: 40px;
  text-align: center;
}

.logo img {
  max-width: 150px;
}

.nav-options {
  flex-grow: 1;
}

.nav-option {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  margin-bottom: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.nav-option img {
  margin-right: 10px;
  width: 20px;
}

.nav-option.active {
  background-color: #e6f2ff;
  color: #3498db;
}

.nav-option:hover {
  background-color: #f4f9ff;
}

.profile-section {
  padding: 15px;
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.profile-section img {
  width: 24px;
  margin-right: 10px;
}

.profile-options {
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 100%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.profile-option {
  padding: 12px 15px;
  transition: background-color 0.3s;
}

.profile-option:hover {
  background-color: #f4f9ff;
}

.main-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0 20px;
}

.messages-container {
  flex-grow: 1;
  overflow-y: auto;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.message {
  display: flex;
  flex-direction: column;
  max-width: 70%;
}

.message.user {
  align-self: flex-end;
}

.message.cola {
  align-self: flex-start;
}

.message-bubble {
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  line-height: 1.5;
}

.message.user .message-bubble {
  background-color: #3498db;
  color: white;
  border-bottom-right-radius: 0;
}

.message.cola .message-bubble {
  background-color: white;
  border-bottom-left-radius: 0;
}

.message-bubble.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
  min-height: 40px;
}

.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin: 0 4px;
  background-color: #3498db;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

.feedback-container {
  display: flex;
  gap: 10px;
  margin-top: 5px;
  padding-left: 5px;
}

.feedback-button {
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.feedback-button:hover, .feedback-button.active {
  opacity: 1;
}

.feedback-button img {
  width: 20px;
}

.input-container {
  display: flex;
  background-color: white;
  padding: 15px 20px;
  border-top: 1px solid #ddd;
  margin: 0 -20px;
  width: calc(100% + 40px);
}

.input-container textarea {
  flex-grow: 1;
  border: 1px solid #ddd;
  resize: none;
  height: 40px;
  padding: 12px;
  font-size: 16px;
  outline: none;
  border-radius: 20px;
  margin-right: 10px;
}

.input-container textarea:disabled {
  background-color: #f9f9f9;
  color: #999;
}

.send-button {
  background-color: #3498db;
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
}

.send-button:hover {
  background-color: #2980b9;
}

.send-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.send-button img {
  width: 20px;
}

.note-section {
  padding: 10px 20px;
  background-color: #f9e79f;
  font-size: 14px;
  color: #7f8c8d;
  text-align: left;
  margin: 0 -20px;
  width: calc(100% + 40px);
}
`, "",{"version":3,"sources":["webpack://./src/components/Dialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B","sourcesContent":[".dialog-container {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  background-color: #f4f4f4;\n  background-size: cover;\n  background-position: center;\n}\n\n.dialog-sidebar {\n  width: 250px;\n  background-color: #f0f8ff;\n  height: 100%;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 10;\n}\n\n.logo {\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n.logo img {\n  max-width: 150px;\n}\n\n.nav-options {\n  flex-grow: 1;\n}\n\n.nav-option {\n  display: flex;\n  align-items: center;\n  padding: 12px 15px;\n  margin-bottom: 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.nav-option img {\n  margin-right: 10px;\n  width: 20px;\n}\n\n.nav-option.active {\n  background-color: #e6f2ff;\n  color: #3498db;\n}\n\n.nav-option:hover {\n  background-color: #f4f9ff;\n}\n\n.profile-section {\n  padding: 15px;\n  border-top: 1px solid #eee;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n}\n\n.profile-section img {\n  width: 24px;\n  margin-right: 10px;\n}\n\n.profile-options {\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  width: 100%;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.profile-option {\n  padding: 12px 15px;\n  transition: background-color 0.3s;\n}\n\n.profile-option:hover {\n  background-color: #f4f9ff;\n}\n\n.main-content {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 20px 0 20px;\n}\n\n.messages-container {\n  flex-grow: 1;\n  overflow-y: auto;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.message {\n  display: flex;\n  flex-direction: column;\n  max-width: 70%;\n}\n\n.message.user {\n  align-self: flex-end;\n}\n\n.message.cola {\n  align-self: flex-start;\n}\n\n.message-bubble {\n  padding: 15px;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  line-height: 1.5;\n}\n\n.message.user .message-bubble {\n  background-color: #3498db;\n  color: white;\n  border-bottom-right-radius: 0;\n}\n\n.message.cola .message-bubble {\n  background-color: white;\n  border-bottom-left-radius: 0;\n}\n\n.message-bubble.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 60px;\n  min-height: 40px;\n}\n\n.dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  margin: 0 4px;\n  background-color: #3498db;\n  border-radius: 50%;\n  animation: bounce 1.4s infinite ease-in-out both;\n}\n\n.dot:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.dot:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}\n\n.feedback-container {\n  display: flex;\n  gap: 10px;\n  margin-top: 5px;\n  padding-left: 5px;\n}\n\n.feedback-button {\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity 0.3s;\n}\n\n.feedback-button:hover, .feedback-button.active {\n  opacity: 1;\n}\n\n.feedback-button img {\n  width: 20px;\n}\n\n.input-container {\n  display: flex;\n  background-color: white;\n  padding: 15px 20px;\n  border-top: 1px solid #ddd;\n  margin: 0 -20px;\n  width: calc(100% + 40px);\n}\n\n.input-container textarea {\n  flex-grow: 1;\n  border: 1px solid #ddd;\n  resize: none;\n  height: 40px;\n  padding: 12px;\n  font-size: 16px;\n  outline: none;\n  border-radius: 20px;\n  margin-right: 10px;\n}\n\n.input-container textarea:disabled {\n  background-color: #f9f9f9;\n  color: #999;\n}\n\n.send-button {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.3s;\n}\n\n.send-button:hover {\n  background-color: #2980b9;\n}\n\n.send-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.send-button img {\n  width: 20px;\n}\n\n.note-section {\n  padding: 10px 20px;\n  background-color: #f9e79f;\n  font-size: 14px;\n  color: #7f8c8d;\n  text-align: left;\n  margin: 0 -20px;\n  width: calc(100% + 40px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
